/** `2024-05-01T00:00:00Z` -> `2024-05-01` for a date input; empty string otherwise. */
export function toDateInputValue(iso?: string | null): string {
  return iso ? iso.slice(0, 10) : '';
}

/** `2024-05-01` from a date input -> an ISO datetime for the API, or null if cleared. */
export function fromDateInputValue(value: string): string | null {
  return value ? new Date(`${value}T00:00:00.000Z`).toISOString() : null;
}

/** ISO UTC instant -> a `datetime-local` input value in the organizer's own local time (the browser handles CET/CEST). */
export function toDateTimeInputValue(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** A `datetime-local` value is local wall-clock time; `toISOString` turns it into the right UTC instant. */
export function fromDateTimeInputValue(value: string): string | null {
  return value ? new Date(value).toISOString() : null;
}
